
import { Navigate } from "react-router-dom";

const ProductedRoute = ({ isLoggedIn, children }) => {
    return(isLoggedIn ? children : <Navigate to="/login" replace />);
};

export default ProductedRoute;
